import Otp from './Otp'

export default Otp
